


























import { Component, Vue } from 'vue-property-decorator'
import { FocusElTableColumn, TableFinalProp } from 'ele-tree-table'

@Component({
  components: { FocusElTableColumn }
})
export default class BaseElement extends Vue {
  data: Array<any> = []
  tableFinalProp = TableFinalProp

  constructor () {
    super()
    for (let index = 0; index < 30; index++) {
      this.data.push({
        id: `${index}`,
        name: `name${index}`,
        logo: index === 0 ? '床前明月光，疑似地上霜。举头望明月，低头思故乡。' : `logo${index}`,
        type: index === 1 ? '云想衣裳花想容，春风拂槛露华浓。若非群玉山头见，会向瑶台月下逢。' : `type${index}`,
        number1: `number1${index}`,
        number2: `number2${index}`,
        number3: `number3${index}`,
        number4: `number4${index}`,
        number5: `number5${index}`,
        hasChildren: true
      })
    }
  }

  handTextChange ({ row, column: { property } }: any, newText: string) {
    row[property] = newText
  }

  load (tree: any, treeNode: any, resolve: any) {
    const index = this.data.length
    resolve([{
      id: `${tree.id}-0`,
      name: `name${index}`,
      logo: `logo${index}`,
      type: `type${index}`,
      number1: `number1${index}`,
      number2: `number2${index}`,
      number3: `number3${index}`,
      number4: `number4${index}`,
      number5: `number5${index}`,
      hasChildren: true
    }])
  }
}
